<template>
	<div class="warp">
		<div class="login">
			<div class="login-card" v-if='nextStep==false'>
				<h2 style="text-align: center;">
					<p style="border-bottom: 2px solid #0052D9;display: inline-block;line-height: 50px;">账号注册</p>
				</h2>
				<div style="padding: 40px;box-sizing: border-box;">
					<el-form :model="invitationCode" label-width="70px" class="demo-ruleForm">
						<el-form-item label="邀请码" prop="code">
							<el-input v-model.number="invitationCode.code" placeholder="请输入您的邀请码"></el-input>
						</el-form-item>

					</el-form>
					<div style="display: flex;font-size: 14px;align-items: center;justify-content: space-between;
			font-family: PingFang;
			font-weight: 500;
			color: #AAAAAA;">
						<p>(没有邀请码？点击加入等候，填写邮箱信息等候邀请)</p>
						<div style="width: 110px;height: 40px;line-height: 40px;text-align: center; background: #E5EDFB;cursor: pointer;font-size: 18px;font-family: PingFang;font-weight: 500;color: #0052D9;"
							@click="centerDialogVisible = true">加入等候</div>
					</div>
					<div style="height: 50px;background: #0052D9;margin-top: 50px;color: white;font-size: 20px;line-height: 50px;text-align: center;"
						@click="verifyWait">
						下一步
					</div>
					<el-dialog title="加入等候名单" :visible.sync="centerDialogVisible" width="30%" :lock-scroll="false"
						center>
						<div style="padding: 20px;box-sizing: border-box;">
							<el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px"
								class="demo-dynamic">
								<el-form-item prop="email" label="邮箱" :rules="[
										      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
										      { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
										    ]">
									<el-input v-model="dynamicValidateForm.email"></el-input>
								</el-form-item>
								<el-form-item prop="reason" label="申请描述" :rules="[
								    { required: true, message: '请输入申请描述', trigger: 'blur' },
								     { min: 5, message: '最少5个字符', trigger: 'blur' }
								  ]">
									<el-input v-model="dynamicValidateForm.reason"></el-input>
								</el-form-item>
							</el-form>
						</div>
						<span slot="footer" class="dialog-footer">
							<el-button @click="centerDialogVisible = false">取 消</el-button>
							<el-button type="primary" @click="addWaitingList">确 定</el-button>
						</span>
					</el-dialog>
				</div>
			</div>
			<div class="login-card" v-if="nextStep">
				<h2 style="text-align: center;">
					<p style="border-bottom: 2px solid #0052D9;display: inline-block;line-height: 50px;">账号注册</p>
				</h2>

				<div style="padding: 40px;box-sizing: border-box;">

					<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="70px"
						class="demo-ruleForm">

						<el-form-item label="邮箱" prop="chekemail">
							<el-input type="text" v-model="ruleForm.chekemail" autocomplete="off"
								placeholder="请输入您的邮箱"></el-input>
						</el-form-item>
						<el-form-item label="密码" prop="pass">
							<el-input type="password" v-model="ruleForm.pass" autocomplete="off"
								placeholder="请输入您的密码"></el-input>
						</el-form-item>
						<el-form-item label="确认密码" prop="checkPass">
							<el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"
								placeholder="请再次输入您的密码"></el-input>
						</el-form-item>

						<el-form-item label="验证码" prop="code">
							<div style="display: flex;">
								<el-input v-model="ruleForm.code" style="flex: 1;" placeholder="请输入验证码"
									type="text"></el-input>
								<div class="inp-yz" :class="{grey:isGrey,blue:!isGrey}" :disabled="dis"
									@click="getCode">
									<span v-if="show">发送验证码</span>
									<span v-else>重新发送({{count}}s)</span>
								</div>
							</div>
						</el-form-item>
						<div class="xieyi">
							<el-checkbox v-model="xyRadio" label="1">同意用户协议</el-checkbox>
							<p @click="$router.replace('/register')">使用手机号注册></p>
						</div>
						<div class="btns">
							<div class="btn-f" @click="$router.replace('/login')">
								返回
							</div>
							<div class="btn-t" @click="submitForm('ruleForm')">
								提交
							</div>
						</div>
					</el-form>
				</div>

				<!-- 	<div class="card-bottom">
					<div class="card-bottom-header">
						<div></div>
						<p>第三方登录</p>
						<div></div>
					</div>
					<div class="card-bottom-boday">
						<div>
							<img src="../../assets/images/wechat.png" @click="wechatLogin" alt="">
						</div>
						<div>
							<img src="../../assets/images/aliPay.png" @click="alipayLogin" alt="">
						</div>
						
					</div>
				</div> -->

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {

			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (value.toString().length < 6) {
						callback(new Error('密码为最少6位'));
					}
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			var checkCode = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('验证码不能为空'));
				} else {
					callback();
				}
			};
			var checkEmail = (rule, value, callback) => {
				const emailReg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/;
				if (!value) {
					return callback(new Error('邮箱号不能为空'));
				} else {
					if (!emailReg.test(value)) {
						callback(new Error('邮箱格式不正确'));
					} else {
						callback()
					}
				}
			};
			return {
				centerDialogVisible: false,
				nextStep: false,
				dynamicValidateForm: {
					domains: [{
						value: ''
					}],
					email: '',
					reason: ''
				},
				centerDialogVisible: false,
				dis: false,
				show: true,
				isGrey: false, //按钮样式
				timer: null, //设置计时器,
				count: "",
				xyRadio: false,
				registerType: 'phone',
				invitationCode: {
					code: ''
				},
				ruleForm: {
					pass: '',
					checkPass: '',
					code: '',
					chekemail: ''
				},
				rules: {

					pass: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						validator: validatePass2,
						trigger: 'blur'
					}],
					code: [{
						validator: checkCode,
						trigger: 'blur'
					}],
					chekemail: [{
						validator: checkEmail,
						trigger: 'blur'
					}],
				}
			};
		},
		mounted() {
			// console.log(this.$store.state.waitCode);
			if (this.$store.state.waitCode) {
				this.invitationCode.code = this.$store.state.waitCode
				this.nextStep = true
			}
		},
		methods: {
			async verifyWait() {
				const verify = await this.$api.verifyWait({
					apply_code: this.invitationCode.code
				})
				if (verify.code == 1) {
					this.$message({
						message: verify.msg,
						type: 'success',
					});
					this.nextStep = true
					this.$store.commit('set_waitCode', this.invitationCode.code)
				} else {
					this.$message({
						message: verify.msg,
						type: 'error',
					});
				}
			},
			async addWaitingList() {
				if (this.dynamicValidateForm.email == '' || this.dynamicValidateForm.reason == '') {
					this.$message({
						message: '请输入邮箱和申请描述',
						type: 'error',
					});
					return
				}
				const emailReg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/;
				if (!emailReg.test(this.dynamicValidateForm.email)) {
					this.$message({
						message: '邮箱格式不正确',
						type: 'error',
					});
					return
				}
				const wait = await this.$api.addWaitingList({
					msg: this.dynamicValidateForm.reason,
					email: this.dynamicValidateForm.email
				})
				if (wait.code == 1) {
					this.$message({
						message: wait.msg,
						type: 'success',
					});
					this.centerDialogVisible = false
				} else {
					this.$message({
						message: wait.msg,
						type: 'error',
					});
				}
			},
			async wechatCheckReg() {
				if (this.$route.query.code) {
					this.bindType = 'wechat'
					let log = await this.$api.getWechatCode({
						code: this.$route.query.code
					})
					console.log(log);
					if (log.data.openid) {
						const bind = await this.$api.wechatCheckBind({
							open_id: log.data.openid
						})
						if (bind.code == 0) {
							this.$message({
								message: '请绑定手机号',
								type: 'error',
								duration: 5000
							});
							this.wechatUserId = log.data.openid
							this.btnText = '绑定'
						} else {
							bind.data.userinfo.login = true
							this.$store.commit('SET_UserInfo', bind.data.userinfo)
							sessionStorage.setItem('userInfo', JSON.stringify(bind.data.userinfo));
							sessionStorage.setItem('token', bind.data.userinfo.token);
							if (bind.data.userinfo.guidance_status == 0) {
								this.$router.replace('/userCenterShow')
							} else {
								this.$router.replace('/userCenter')
							}
						}
					} else {
						this.$message({
							message: '授权失败',
							type: 'error'
						});

					}
				} else {
					return
				}
			},
			async alipayCheckReg() {
				if (this.$route.query.auth_code) {
					this.bindType = 'alipay'
					let log = await this.$api.alipayLogin({
						auth_token: this.$route.query.auth_code
					})
					if (log.code == 1) {
						const bind = await this.$api.alipayCheckBind({
							alipay_user_id: log.data.user_id
						})
						if (bind.code == 0) {
							this.$message({
								message: '请绑定手机号',
								type: 'error',
								duration: 5000
							});
							this.alipayUserId = log.data.user_id
							this.btnText = '绑定'
						} else {
							bind.data.userinfo.login = true
							this.$store.commit('SET_UserInfo', bind.data.userinfo)
							sessionStorage.setItem('userInfo', JSON.stringify(bind.data.userinfo));
							sessionStorage.setItem('token', bind.data.userinfo.token);
							if (bind.data.userinfo.guidance_status == 0) {
								this.$router.replace('/userCenterShow')
							} else {
								this.$router.replace('/userCenter')
							}
						}
					}
				} else {
					return
				}
			},
			// msgMobileLogin
			alipayLogin() {
				location.href =
					'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021004116690108&scope=auth_user&redirect_uri=https%3a%2f%2fwww.zhaowaixie.com%2f%23%2flogin';
			},
			wechatLogin() {
				location.href =
					'https://open.weixin.qq.com/connect/qrconnect?appid=wx4658885ebd2e3204&redirect_uri=https%3a%2f%2fwww.zhaowaixie.com%2f%23%2flogin&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect'
			},
			async getCode() {
				let TIME_COUNT = 60;
				const emailReg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/;
				if (emailReg.test(this.ruleForm.chekemail)) {
					if (!this.timer) {
						this.count = TIME_COUNT;
						this.isGrey = true;
						this.show = false;
						this.dis = true;
						const yzcode = await this.$api.sendEmailCode({
							event: 'register',
							email: this.ruleForm.chekemail
						})
						console.log(yzcode.code);
						if (yzcode.code == 1) {
							this.$message({
								message: yzcode.msg,
								type: 'success'
							});
							this.timer = setInterval(() => {
								if (this.count > 0 && this.count <= TIME_COUNT) {
									this.count--;
								} else {
									this.dis = false;
									this.isGrey = false;
									this.show = true;
									clearInterval(this.timer);
									this.timer = null;
								}
							}, 1000);
						} else {
							this.$message({
								message: yzcode.msg,
								type: 'warning'
							});
						}
					}
				} else {
					this.$message.error('邮箱格式错误');
				}

			},
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						if (this.xyRadio) {
							const register = await this.$api.registerByEmail({
								code: this.ruleForm.code,
								email: this.ruleForm.chekemail,
								password: this.ruleForm.pass,
								apply_code: this.invitationCode.code
							})
							console.log(register);
							if (register.code == 1) {
								this.$message({
									message: register.msg,
									type: 'success'
								});
								this.$router.replace('/login')
								this.$store.commit('set_waitCode', '')
							} else {
								this.$message({
									message: register.msg,
									type: 'warning'
								});
							}
						} else {
							this.$message.error('请同意用户协议');
						}
					} else {

						this.$message.error('请填写完整信息');
						return false;
					}
				});
			},
		}
	}
</script>

<style scoped>
	.xieyi {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 13px;
	}

	.xieyi>p {
		cursor: pointer;
	}

	.btns {
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.btns>.btn-t {
		background: #0052D9;
		color: white;
	}

	.btns>div {
		cursor: pointer;
		text-align: center;
		line-height: 45px;
		width: 160px;
		height: 45px;
		color: #0052D9;
		border: 1px solid #0052D9;
	}

	.el-input__inner {
		background-color: #F6F6F6 !important;

	}

	.inp-yz {
		cursor: pointer;
		width: 100px;
		height: 40px;
		background: #E5EDFB;
		margin-left: 8px;
		color: #0052D9;
		line-height: 40px;
		text-align: center;
	}

	.card-bottom-boday {
		margin-top: 40px;
		display: flex;
		justify-content: space-around;
	}

	.card-bottom-boday>div>img {
		width: 45px;
		height: 45px;
		cursor: pointer;
	}

	.card-bottom {
		box-sizing: border-box;
		padding: 0 70px;
		margin-bottom: 30px;
	}

	.card-bottom-header {
		display: flex;
		width: 100%;
		font-size: 14px;
		justify-content: space-between;
		align-items: center;
		color: #888888;
	}

	.card-bottom-header>div {
		height: 1px;
		width: 115px;
		background: #DCDCDC;
	}


	.login {
		padding-top: 80px;
	}

	.login-card>h2 {
		border-bottom: 1px solid #E5E5E5;

	}

	.login-card {
		position: relative;
		margin: 0 auto;
		box-sizing: border-box;
		padding-top: 20px;
		width: 530px;
		background: #FFFFFF;
		border: 1px solid #E7E7E7;
		box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.16);
		border-radius: 5px;
	}

	.warp {
		background: url('../../assets/images/loginBG.png') no-repeat;
		background-size: cover;
		width: 100%;
		height: 870px;
	}
</style>